import { FaCocktail, FaHiking, FaShuttleVan, FaBeer } from "react-icons/fa";

const services = [
  {
    icon: <FaCocktail />,
    title: "Free Cocktails",
    info: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Alias molestias eius libero?",
  },
  {
    icon: <FaHiking />,
    title: "Endless Hiking",
    info: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Alias molestias eius libero?",
  },
  {
    icon: <FaShuttleVan />,
    title: "Free Shuttle",
    info: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Alias molestias eius libero?",
  },
  {
    icon: <FaBeer />,
    title: "Strongest Be",
    info: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Alias molestias eius libero?",
  },
];

export default services;
